const testimonials = [
  {
    quote: "I take this opportunity to thank you for your timely support and guidance during our son Abhishek's admission in Nashville State Community College this fall semester. Your timely advice and personal touch made the entire admission process easy and stress-free. I really appreciate your effort in driving us to NSCC and introducing us to the International Student Advisor, Adriane, who guided us through the admission process. You are a mentor to Abhishek guiding him to do great in his academics. Your wide network in Nashville education institutions, including Belmont is amazing. I am grateful for your professionalism and knowledge in the education sector, that helped us immensely. We wish you all the very best!! Thanks again, Warm Regards.",
    name: "Jyoti",
    role: "Mother of Raj Sinha",
    date: "11/25/2022",
    initials: "J"
  },
  {
    quote: "Hi Dr. Hull, Through the difficult periods of my life, Dr. Mani Hull has not only given me the care & support that I needed but also helped me to grow into the person I've wanted to become for so long. Whenever I have a conversation with her, I appreciate her wisdom and humor. I really am blessed to have gotten to know Dr. Hull these past couple of years because she changed my life for the better",
    name: "Kahwit",
    role: "Graduate of Lipscomb University",
    date: "11/09/2022",
    initials: "K"
  },
  {
    quote: "Dr. Hull exceeded all of my expectations assisting my daughter completing her graduate application to Vanderbilt University. Dr. Hull was engaging, knowledgeable, thorough and a pleasure to work with. Her personal knowledge of the doctorate application process coupled with her desire to help people is beyond measure. She spent a great deal of time getting to know my daughter Lauren as well as her future goals. She created a step-by-step plan including time frames to guide us through the process. I highly recommend her services to anyone looking to apply to college at any level.",
    name: "Nora Fielding",
    role: "Mother of Lauren Fielding",
    date: "10/05/2022",
    initials: "NF"
  },
  {
    quote: "Dr. Hull: You have been absolutely incredible in helping me be informed about my options. By going through possible schools, dates and deadlines, requirements, etc., you have helped me navigate the confusing world of graduate school applications. From your well-earned experience to your encouraging words, you have been such a blessing. I couldn't have done it without you!",
    name: "Lauren Fielding",
    role: "",
    date: "10/04/2022",
    initials: "LF"
  },
  {
    quote: "Hi Mani Aunty. Today I received my acceptance letter from NSCC. Thank you so much for everything that you have done for us, you've quite literally been a godsend. My mother and I are so grateful for your strong but kind words, more than half of what we did was not possible without you. Thank you so much once again.",
    name: "Raj Sinha",
    role: "",
    date: "05/13/2023",
    initials: "RS"
  },
  {
    quote: "I was delighted with the service provided by AES. Their team was not only exceedingly friendly, and helpful, but they also simplified and streamlined the entire US student visa process. I wholeheartedly recommend their services.",
    name: "Heman",
    role: "University of California, Riverside",
    date: "",
    initials: "H"
  },
  {
    quote: "AES provided exceptional support throughout my US student visa process. Despite the time constraints in managing my student visa application, they consistently displayed promptness in addressing my needs. Post my visa grant, AES further assisted me in securing accommodation in Nashville and arranging airport pick-up. My experience with AES has been truly outstanding, and I wholeheartedly endorse them to prospective students.",
    name: "Anupreeta Pinjan",
    role: "Trevecca Nazarene University",
    date: "",
    initials: "AP"
  },
  {
    quote: "I express my heartfelt gratitude to Alpesa Education Services (AES) for their pivotal role in the success of my US visa application. Their performance was consistently excellent throughout the entire process, characterized by trustworthiness and ethical conduct. I wholeheartedly recommend their services to aspiring students planning to study abroad.",
    name: "Kumar Manglam",
    role: "Westcliff University",
    date: "",
    initials: "KM"
  },
  {
    quote: "AES made the entire process exceptionally smooth for me, from advising the right institution, course, and location to preparing for the visa interview. My journey with AES has been remarkable, and I'm profoundly grateful for their efforts that contributed to my higher education success.",
    name: "Varsha",
    role: "Tennessee Tech University",
    date: "",
    initials: "V"
  }
];

export default testimonials;
